import { createIcon } from '../createIcon';

export const FeatherAltIconConfig = {
  name: 'FeatherAltIcon',
  height: 512,
  width: 512,
  svgPath: 'M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z',
  yOffset: 0,
  xOffset: 0,
};

export const FeatherAltIcon = createIcon(FeatherAltIconConfig);

export default FeatherAltIcon;